export default __webpack_public_path__ + "images/phone-camera-NpxzL.png";